import { render, staticRenderFns } from "./Swap.vue?vue&type=template&id=e5ce8ac0&"
import script from "./Swap.vue?vue&type=script&lang=js&"
export * from "./Swap.vue?vue&type=script&lang=js&"
import style0 from "./Swap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports